export const waitingRoom = {
  title: {
    visitCancelled: 'Tu visita ha sido cancelada.',
    weMissedYou: '¡Lamentamos haberte perdido, {{ name }}!',
    visitExpired: 'Tu enlace de visita ha expirado.',
    teamNotified: '{{ name }}, su cita ha sido confirmada con el próximo proveedor disponible.',
    appointmentFinished: '¡Gracias por confiar en nosotros para tu atención hoy, {{ name }}!',
    visitInProgress: 'Tu consulta está en curso...',
    readyToSee: 'Tu {{ medicalTeam }} está listo para verte, {{ name }}.',
    cancelVisit: 'Cancelar visita',
    offHours: '{{ name }}, tu {{ medicalTeam }} estará disponible {{ day }} a las {{ time }}.',
    preferredPharmacy: 'Tu farmacia preferida',
    nextStep: 'Tu próximo paso',
    makeChange: '¿Necesita hacer un cambio?',
    getReady: 'Preparémonos para tu visita, {{ name }}.',
    oneTime: 'una sola vez',
    signThe: 'Firma el',
    signConsentForm: 'formulario de consentimiento que te preparará para todas tus futuras visitas.',
  },
  subtitle: {
    closePage: 'Puedes cerrar esta página si lo deseas.',
    sendYouLink: 'Te enviaremos un nuevo enlace por mensaje de texto y correo electrónico.',
    linkNoLongerActive: 'Este enlace ya no está activo, pero aún puedes programar una nueva visita.',
    whenTeamIsReady:
      'Te enviaremos un mensaje de texto y un correo electrónico cuando tu {{ medicalTeam }} esté listo. Puedes cerrar esta página si lo deseas.',
    greatTalk:
      'Te enviaremos un resumen de tu visita y los próximos pasos, que podrás consultar en tu app de Next Level Medical.',
    readyForVisit: '{{ provider }} está listo para tu consulta.',
    reasonForCancel: '¿Cuál es el motivo de la cancelación?',
    areYouSure: '¿Estás seguro de que deseas cancelar la consulta?',
    offHours:
      'Te enviaremos un mensaje de texto y un correo electrónico a las {{ time }}. Puedes cerrar esta página si lo deseas.',
    weMessage: 'Te enviaremos un mensaje cuando tu {{ medicalTeam }} esté listo.',
    visit: 'visita',
    inLine: 'en la fila',
    noPharmacy: 'Aún no se ha agregado una farmacia.',
    medicalTeam: 'equipo médico',
  },
  label: {
    primeWl: 'Consulta virtual de Next Level',
  },
  time: {
    today: 'hoy',
    tomorrow: 'mañana',
  },
  actions: {
    returnToHome: 'Volver a inicio',
    updateOrCancel: 'Actualizar o cancelar esta visita',
    joinNow: 'Unirse ahora',
    confirmAndCancel: 'Confirmar y cancelar',
    cancelConsultation: 'Cancelar consulta',
    goHome: 'Ir a inicio',
    updatePharmacy: 'Actualizar farmacia',
    close: 'Cerrar',
    scheduleForLater: 'Programar para más tarde',
    goBackHome: 'Volver al inicio',
    addPharmacy: 'Agregar farmacia',
    signConsent: 'Firmar consentimiento',
    rejoinVisit: 'Volver a unirse a la visita',
  },
  errors: {
    failedToLoad: 'No se pudo cargar la sala de espera',
    failedToLoadPharmacy: 'No se pudo cargar la farmacia preferida',
    failedToCancelVisit: 'No se pudo cancelar la visita',
    failedToFetchPatientsInLine: 'No se pudo obtener la lista de pacientes en espera',
    noSlotsFound: 'No hay citas disponibles',
  },
};
